export default __webpack_public_path__ + "static/media/linechart.418e009d.png";